<script setup>
import Header from '@/components/Header'
import DesignFooter from '@/components/DesignFooter.vue'
import { childItem } from './contant.js'

const data = childItem.pectorophony
const asset = (path) => `${import.meta.env.BASE_URL}${path}`
const description = '融合离线语音控制与环境声音分类感知，引领智能家居、家电行业进入主动感知新时代'
const painPoints = [
  { title: '依赖云端识别方案导致延迟大，存在隐私泄露风险', icon: 'timeout' },
  { title: '在嘈杂环境或远距离场景下，语音控制效果不佳', icon: 'noise' },
  { title: '无法主动感知用户状态与环境变化，难以智能调节家居家电运行模式', icon: 'active' },
]
const sceneImages = ['pectorophony-2.jpg', 'pectorophony-3.jpg']
</script>

<template>
  <Header design-always hide-banner />
  <main class="audio-modules-page">
    <section class="hero" aria-labelledby="audio-modules-title">
      <img :src="asset('image/solution-redesign/audio-modules-banner.png')" class="hero-image" alt="" fetchpriority="high" />
      <div class="solution-container hero-content">
        <p class="breadcrumb">解决方案 / {{ data.name }}</p>
        <h1 id="audio-modules-title">{{ data.name }}</h1>
        <p class="hero-description">{{ description }}</p>
      </div>
    </section>

    <section class="solution-section muted" aria-labelledby="audio-modules-background">
      <div class="solution-container stack">
        <h2 id="audio-modules-background">业务背景</h2>
        <p class="background-copy">{{ data.businessBg }}</p>
      </div>
    </section>

    <section class="solution-section" aria-labelledby="audio-modules-pain">
      <div class="solution-container stack">
        <h2 id="audio-modules-pain">行业痛点</h2>
        <div class="pain-grid">
          <article v-for="point in painPoints" :key="point.icon" class="pain-card">
            <span class="pain-icon" aria-hidden="true"><img :src="asset(`svg/${point.icon}.svg`)" alt="" width="24" height="24" loading="lazy" /></span>
            <h3>{{ point.title }}</h3>
          </article>
        </div>
      </div>
    </section>

    <section class="solution-section muted" aria-labelledby="audio-modules-overview">
      <div class="solution-container stack">
        <h2 id="audio-modules-overview">方案概述</h2>
        <!-- 可信静态正文：完整保留环境感知、离线控制、降噪与硬件参数。 -->
        <div class="rich-copy" v-html="data.pectorophonyScheme" />
        <img :src="asset('new-image/industry/pectorophony-1.jpg')" class="overview-image" alt="移远通信VA500-GL AI音频模组" loading="lazy" decoding="async" />
      </div>
    </section>

    <section class="solution-section" aria-labelledby="audio-modules-scenes">
      <div class="solution-container stack">
        <h2 id="audio-modules-scenes">应用场景</h2>
        <p class="section-description">按使用场景和设备条件选择能力。</p>
        <div class="scene-grid">
          <article v-for="(scene, index) in data.pectorophonyApply" :key="scene.name" class="scene-card">
            <img :src="asset(`new-image/industry/${sceneImages[index]}`)" :alt="scene.name" class="scene-image" loading="lazy" decoding="async" />
            <div class="scene-body"><h3>{{ scene.name }}</h3><p>{{ scene.dec }}</p></div>
          </article>
        </div>
      </div>
    </section>

    <section class="solution-section muted" aria-labelledby="audio-modules-cases">
      <div class="solution-container stack">
        <h2 id="audio-modules-cases">相关案例</h2>
        <div class="case-grid">
          <a v-for="item in data.caseImg" :key="item.link" :href="item.link" class="case-card" v-track="{ position: 'solution > case', page: 'audio-modules', case: item.title || item.name || item.link.split('?')[0] }" target="_blank" rel="noopener noreferrer">
            <img :src="asset('new-image/industry/pectorophony-4.png')" alt="" class="case-image" loading="lazy" decoding="async" />
            <div class="case-body">{{ item.dec }}</div>
          </a>
        </div>
      </div>
    </section>
  </main>
  <DesignFooter />
</template>

<style scoped>
.audio-modules-page { min-width: 0; color: #14233b; background: #fff; }
.audio-modules-page, .audio-modules-page *, .audio-modules-page *::before, .audio-modules-page *::after { box-sizing: border-box; }
.solution-container { width: min(1440px, calc(100% - 48px)); margin-inline: auto; }
.audio-modules-page h1, .audio-modules-page h2, .audio-modules-page h3, .audio-modules-page p { margin: 0; }
.audio-modules-page h2 { color: #14233b; font-size: 24px; font-weight: 500; line-height: 1.4; text-align: center; }
.solution-section { padding-block: 64px; }
.muted { background: #f4f7fb; }
.stack { display: flex; flex-direction: column; gap: 24px; }
.hero { position: relative; display: flex; align-items: center; min-height: 352px; padding-block: 64px; color: #fff; background: #0d182b; }
.hero-image { position: absolute; inset: 0; width: 100%; height: 100%; object-fit: cover; }
.hero-content { position: relative; }
.breadcrumb { margin-bottom: 8px !important; font-size: 14px; line-height: 24px; }
.hero h1 { margin-bottom: 16px; color: #fff; font-size: 30px; font-weight: 600; line-height: 1.35; overflow-wrap: anywhere; }
.hero-description { font-size: 16px; line-height: 1.5; }
.background-copy, .section-description { color: #617089; font-size: 15px; line-height: 29px; text-align: center; }
.pain-grid { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 24px; align-items: stretch; }
.pain-card, .scene-card, .case-card { min-width: 0; border: 1px solid #dce2ea; border-radius: 16px; background: #fff; }
.pain-card { display: flex; align-items: center; gap: 16px; padding: 24px; }
.pain-icon { display: flex; flex: 0 0 40px; align-items: center; justify-content: center; width: 40px; height: 40px; border-radius: 50%; background: #f4f7fb; }
.pain-icon img { display: block; width: 24px; height: 24px; }
.audio-modules-page h3 { color: #14233b; font-size: 18px; font-weight: 500; line-height: 1.5; }
.rich-copy { color: #617089; font-size: 15px; line-height: 29px; overflow-wrap: break-word; }
.rich-copy :deep(b) { color: #14233b !important; font-size: 18px; font-weight: 500; }
.overview-image { display: block; width: 100%; height: auto; border-radius: 16px; }
.scene-grid { display: flex; flex-wrap: wrap; justify-content: center; align-items: stretch; gap: 24px; }
.scene-card { display: flex; flex-direction: column; flex: 0 0 calc((100% - 48px) / 3); overflow: hidden; }
.scene-image { display: block; width: 100%; aspect-ratio: 16 / 9; object-fit: cover; }
.scene-body { flex: 1; padding: 24px; }
.scene-body h3 { margin-bottom: 8px; }
.scene-body p { color: #617089; font-size: 14px; line-height: 24px; }
.case-grid { display: grid; grid-template-columns: minmax(0, 1fr); width: calc((100% - 48px) / 3); margin-inline: auto; gap: 24px; align-items: stretch; }
.case-card { display: flex; flex-direction: column; overflow: hidden; color: #14233b; text-decoration: none; transition: border-color 160ms ease, box-shadow 160ms ease; }
.case-image { display: block; width: 100%; aspect-ratio: 900 / 383; object-fit: contain; background: #fff; }
.case-body { flex: 1; padding: 24px; font-size: 16px; line-height: 24px; }
.case-card:hover { color: #14233b; border-color: #9baabd; box-shadow: 0 8px 24px rgb(20 35 59 / 8%); }
.case-card:focus-visible { outline: 3px solid #1478d4; outline-offset: 4px; }
@media (min-width: 768px) { .audio-modules-page h2 { font-size: 26px; } .hero h1 { font-size: 36px; } .hero-description { font-size: 18px; } }
@media (min-width: 992px) { .audio-modules-page h2 { font-size: 28px; } .hero h1 { font-size: 40px; } .hero-description { font-size: 18px; } }
@media (min-width: 1200px) { .audio-modules-page h2 { font-size: 30px; } .hero h1 { font-size: 44px; } .hero-description { font-size: 18px; } }
@media (min-width: 1400px) { .audio-modules-page h2 { font-size: 32px; } }
@media (max-width: 991px) { .pain-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); } .scene-card { flex-basis: calc((100% - 24px) / 2); } .case-grid { width: calc((100% - 24px) / 2); } }
@media (max-width: 767px) {
  .solution-container { width: calc(100% - 32px); }
  .solution-section { padding-block: 40px; }
  .hero { min-height: 280px; padding-block: 40px; }
  .pain-grid { grid-template-columns: minmax(0, 1fr); }
  .scene-card { flex-basis: 100%; }
  .case-grid { width: 100%; }
}
@media (prefers-reduced-motion: reduce) { .case-card { transition: none; } }
</style>